import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { LayoutComponent } from './layout.component'

const routes: Routes = [
	{
		path: '',
		component: LayoutComponent,
		children: [
			{
				path: '',
				redirectTo: 'service-providers',
				pathMatch: 'full',
			},
			{
				path: 'service-providers',
				loadChildren: () =>
					import('../../modules/organization/organization.module').then(
						(m) => m.OrganizationModule
					),
			},
			{
				path: 'booking',
				loadChildren: () =>
					import('../../modules/booking/booking.module').then(
						(m) => m.BookingModule
					),
			},
			{
				path: 'offer',
				loadChildren: () =>
					import('../../modules/offers/offer.module').then(
						(m) => m.OfferModule
					),
			},
			{
				path: 'notifications',
				loadChildren: () =>
					import('../../modules/notifications/notifications.module').then(
						(m) => m.NotificationsModule
					),
			},
			{
				path: 'clients',
				loadChildren: () =>
					import('../../modules/clients/clients.module').then(
						(m) => m.ClientsModule
					),
			},
			{
				path: 'packages',
				loadChildren: () =>
					import('../../modules/packages/package.module').then(
						(m) => m.PackageModule
					),
			},
			{
				path: 'roles-permissions',
				loadChildren: () =>
					import(
						'../../modules/roles-and-permissions/roles-and-permissions.module'
					).then((m) => m.RolesAndPermissionsModule),
			},
			{
				path: 'users',
				loadChildren: () =>
					import('../../modules/users/users.module').then((m) => m.UsersModule),
			},
			{
				path: 'logs',
				loadChildren: () =>
					import('../../modules/logs/logs.module').then((m) => m.LogsModule),
			},

			{
				path: 'refunds',
				loadChildren: () =>
					import('../../modules/refund/refund.module').then(
						(m) => m.RefundModule
					),
			},
			{
				path: 'wallet',
				loadChildren: () =>
					import('../../modules/wallet/wallet.module').then(
						(m) => m.WalletModule
					),
			},
			{
				path: 'payouts',
				loadChildren: () =>
					import('../../modules/payout/payout.module').then(
						(m) => m.PayoutModule
					),
			},
			{
				path: 'settings',
				loadChildren: () =>
					import('../../modules/settings/settings.module').then(
						(m) => m.SettingsModule
					),
			},
			{
				path: 'store',
				loadChildren: () =>
					import('../../modules/store/store.module').then((m) => m.StoreModule),
			},
			{
				path: 'store/products',
				loadChildren: () =>
					import('../../modules/products/products.module').then(
						(m) => m.ProductsModule
					),
			},
			{
				path: 'reviews',
				loadChildren: () =>
					import('../../modules/reviews/reviews.module').then(
						(m) => m.ReviewsModule
					),
			},
			{
				path: 'pointing-system',
				loadChildren: () =>
					import('../../modules/pointing-system/pointing-system.module').then(
						(m) => m.PointingSystemModule
					),
			},
			{
				path: 'customizing-mobile-app',
				loadChildren: () =>
					import(
						'../../modules/customizing-mobile-app/customizing-mobile-app.module'
					).then((m) => m.CustomizingMobileAppModule),
			},
			

			{
				path: 'order-return',
				loadChildren: () =>
					import('../../modules/order-return/order-return.module').then(
						(m) => m.OrderReturnModule
					),
			},
			{
				path: '**',
				redirectTo: 'service-providers',
				pathMatch: 'full',
			},
		],
	},
]

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class LayoutRoutingModule {}
